import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { getRelatedIds } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/helpers'
import parcelServices from '@/parcels/services/services'

import { getPickableParcels } from './helpers'

const useGeneratePickingList = ({ storeId, setToastInfo, setSelectedParcels, selectedParcels }) => {
  const [showGeneratePickingListModal, setShowGeneratePickingListModal] = useState(false)

  const { fetchData: generatePickingList, loading: generatingPickingList } = useFetch(
    parcelServices.generatePickingList,
    {
      doInitialRequest: false,
    }
  )

  const openGeneratePickingListModal = () => {
    setShowGeneratePickingListModal(true)
  }

  const closeGeneratePickingListModal = () => {
    setShowGeneratePickingListModal(false)
  }

  const onGeneratePickingList = async parcelIds => {
    try {
      const response = await generatePickingList({
        storeId,
        payload: { ids: getRelatedIds(selectedParcels, parcelIds) },
      })

      if (response?.file_url) {
        window.open(response?.file_url, '_blank', 'noopener, noreferrer')
      }

      closeGeneratePickingListModal()
      setSelectedParcels([])
    } catch (error) {
      closeGeneratePickingListModal()
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showGeneratePickingListModal,
    openGeneratePickingListModal,
    closeGeneratePickingListModal,
    generatingPickingList,
    onGeneratePickingList,
    pickableParcels: getPickableParcels(selectedParcels),
  }
}

export default useGeneratePickingList
